import _ from "lodash";

export const pickProps = (props, startString) => {
  return _.mapKeys(
    _.pickBy(props, (val, prop) => prop.startsWith(startString)),
    (val, prop) => _.camelCase(prop.replace(startString, ""))
  );
};



export const delayPromise = (timeout, result) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(result);
    }, timeout);
  });
};

/**
 * Converts a string to a boolean. If the argument supplied is not a string, it will be casted to one
 * @param {string} string Options `true`, `yes`, `1` resolves to `true`, all other values resolve to false.
 * @returns {boolean}
 */
export const stringToBoolean = (string) => {
  if (typeof string !== 'string') {
    string = String(string);
  }
  switch (string.toLowerCase().trim()) {
    case 'true':
    case 'yes':
    case '1':
      return true;
    case 'undefined':
    case 'false':
    case 'no':
    case '0':
    case 'null':
    default:
      return false;
  }
};
